import { Component, OnInit } from '@angular/core';
import { iframePageState } from '../../app.constants';
import {AbstractAchooComponent} from '../abstract-achoo.component';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'admin-content',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent extends AbstractAchooComponent implements OnInit {
  public route: string;
  constructor(protected userService: UserService) {
    super(userService);
  }

  companyChangeCallback(companyId) {
    // callback when switching account
  }


  ngOnInit() {
    super.ngOnInit();
    this.route = iframePageState.admin;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/admin/admin.component.ts